import type { HTMLProps } from 'react';

import { cn } from '@/lib/utils';

type LoadingSpinnerProps = HTMLProps<HTMLDivElement> & {
  loadingText?: string;
  size?: number;
  thickness?: number;
};

export const LoadingSpinner = function ({
  loadingText,
  size = 50,
  thickness = 4,
  className = '',
  ...props
}: LoadingSpinnerProps) {
  return (
    <div
      className={cn(
        className,
        'loading-spinner-container flex flex-col gap-1 justify-center items-center',
      )}
      {...props}
    >
      <div
        style={{ width: size, height: size, borderWidth: thickness }}
        className="loading-spinner border-4 rounded-full border-slate-300 border-t-emerald-500 animate-spin"
      ></div>
      {loadingText && <p className="text-gray-50 italic">{loadingText}</p>}
    </div>
  );
};
